var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsynCardContainer',{attrs:{"sizes":{
    default: 12,
    sm: 12,
    lg: 12
  },"loading":_vm.loading,"visibleCard":_vm.visibleCard}},[(!_vm.loading)?_c('Table',{attrs:{"fields":_vm.fields,"items":_vm.items,"rowClickable":_vm.rowClickable}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }